/**
 * WebSocket Configuration for Web Dashboard
 * Centralized config for different environments
 *
 * NOTE: Updated to use Native WebSocket for AWS API Gateway compatibility
 * The backend now supports Native WebSocket at /ws/chat path
 */

import { wsLogger } from '../utils/logger';

export type Environment = 'development' | 'staging' | 'production';

/**
 * Determine current environment
 */
const getEnvironment = (): Environment => {
  // Check NODE_ENV first
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }

  // Check custom env variable (for staging)
  if (process.env.REACT_APP_ENV === 'staging') {
    return 'staging';
  }

  // Default to development
  return 'development';
};

/**
 * WebSocket Server URLs for each environment
 * Backend uses Native WebSocket at /ws/chat path
 */
export const SOCKETIO_URLS: Record<Environment, string> = {
  development: process.env.REACT_APP_SOCKETIO_ENDPOINT || 'http://localhost:4000',
  staging: 'https://staging-api.hybservice.com',
  production: 'https://api.hybservice.com',
};

/**
 * WebSocket Path - for Native WebSocket
 */
export const WS_PATH = '/ws/chat';

/**
 * Current environment
 */
export const CURRENT_ENV: Environment = getEnvironment();

/**
 * Current Socket.IO Server URL based on environment
 */
export const SOCKETIO_URL = SOCKETIO_URLS[CURRENT_ENV];

/**
 * Feature Flags
 * CHAT_ENABLED: Set to 'true' to enable WebSocket connections
 */
export const CHAT_ENABLED = process.env.REACT_APP_CHAT_ENABLED === 'true';

/**
 * Log current configuration (development only)
 */
if (CURRENT_ENV === 'development') {
  wsLogger.debug('[WebSocket Config]', {
    environment: CURRENT_ENV,
    url: SOCKETIO_URL,
    path: WS_PATH,
    chatEnabled: CHAT_ENABLED,
  });
}
